/**
 * FooterInfo component.
 * @module components/theme/Footer/FooterInfo
 *
 * - Added StickyBlocks
 */

import React from 'react';
import { Container, Segment } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import { StickyBlocks } from 'volto-sticky-blocks';

/**
 * Component to display info above the main footer.
 * @function FooterInfo
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const FooterInfo = () => {
  return (
    <Segment vertical id="pre-footer">
      <StickyBlocks container={Container} />
    </Segment>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
FooterInfo.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(FooterInfo);
